import type { TeachingLearningSequenceFragment } from '../../../activity-builder/components/teaching-notes/teaching-notes.graphql.generated';
import { LEARNING_SEQUENCE_CATEGORY_ACTIVITY_DESCRIPTION } from 'global/constants';

export function getActivityPartsSequenceItems(
  sequences: TeachingLearningSequenceFragment[] | null,
  componentId: string
) {
  return (
    sequences?.filter(
      s =>
        s.category === LEARNING_SEQUENCE_CATEGORY_ACTIVITY_DESCRIPTION &&
        s.component?.id === componentId
    ) || []
  );
}
